import { storyActions } from "../../actionTypes";

const initialState = {
	story: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case storyActions.UPDATE_STORY: {
			return { ...state, ...initialState };
		}

		case storyActions.UPDATE_STORY_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				story: action.payload,
			};
		}

		case storyActions.UPDATE_STORY_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
